import $ from 'jquery';
import enquire from 'enquire.js';

$(() => {
  enquire.register('screen and (min-width:1024px)', {
    match: () => {
      $(window).on('load', () => {
        $('.main-head-shrinkable').headshrinker({
          shrinkOffset: 80,
        });
      });
    },
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/head-shrink.js
 **/